import { MessageSquare } from '@/components/icons';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { openFeedbackModal } from './feedback-store';

/**
 * Floating bottom-right Send-Feedback button. Mounted once in the
 * authenticated AppShell. The data-tour id matches the W10-F3-S1
 * onboarding step that points at it.
 *
 * Hidden on `/embed/*` routes — those are iframe-friendly views and a
 * floating button would break the embedded surface.
 */
export function FeedbackButton(): JSX.Element | null {
  const { t } = useTranslation();
  if (typeof window !== 'undefined' && window.location.pathname.startsWith('/embed/')) {
    return null;
  }
  return (
    <Button
      variant="default"
      size="sm"
      onClick={() => openFeedbackModal()}
      data-tour="feedback-button"
      className="fixed bottom-5 right-5 z-40 shadow-lg"
      aria-label={t('feedback.button.aria')}
    >
      <MessageSquare className="mr-2 h-4 w-4" aria-hidden="true" />
      {t('feedback.button.label')}
    </Button>
  );
}
